module.exports = __webpack_public_path__ + "06_short_black.35eb77a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/06_short_black.png
// module id = sSPL
// module chunks = 0